import React from 'react';
import { Link } from 'react-router';
import cx from 'classnames';

import Footer from '~/components/footer';
import { homeRoute } from '~/routes';

import styles from '~/components/layouts/layouts.module.scss';

const LandingPageLayout = ({ headerVariant, layoutVariant, children }) => {
  return (
    <>
      <header
        className={cx(styles.nav, {
          [styles.simpleHeader]: layoutVariant === 'simplified',
        })}
      >
        <nav
          className={cx('container', styles.navInner, {
            [styles.simpleNav]: layoutVariant === 'simplified',
          })}
        >
          <Link className={styles.navLogoLink} to={homeRoute()}>
            <img
              className={styles.navLogo}
              src={`/images/logo-${
                headerVariant === 'light' ? 'white' : 'black'
              }.svg?v1`}
              alt="Sunday Lawn & Garden Care"
            />
          </Link>
        </nav>
      </header>

      <main className="main">{children}</main>

      {layoutVariant === 'simplified' ? <SimpleFooter /> : <Footer />}
    </>
  );
};

export default LandingPageLayout;

export const SimpleFooter = () => (
  <footer className={cx('footer', styles.simpleFooter)}>
    <div className={cx('container', styles.footerInner)}>
      <Link className={styles.footerLogoLink} to={homeRoute()}>
        <img
          className={styles.footerLogo}
          src="/images/logo-white.svg?v1"
          alt="Sunday Lawn & Garden Care"
        />
      </Link>
    </div>
  </footer>
);
